@let isLogoutEnabled = isLogoutEnabled$ | async;
@let isLogoEnabled = isLogoEnabled$ | async;
@let isHelpCenterEnabled = isHelpCenterEnabled$ | async;
@let collapsedOpen = collapsedOpen$ | async;
@let logo = logoUrl$ | async;
@let org = org$ | async;
@let username = userName$ | async;
@let isDesktop = isDesktop$ | async;
@let userVisible = userVisible$ | async;
@let isLocked = isLocked$ | async;

<div
  [class.collapsed]="collapsed"
  [class.open]="collapsed && collapsedOpen"
  class="vex-sidenav flex flex-col">
  <div class="vex-sidenav-toolbar__container">
    @if (isLogoEnabled) {
      <div class="sidenav-toolbar flex-none flex items-start">
        <img
          alt="Logo"
          class="select-none flex-none"
          [src]="logo" />
        <!-- <h2 class="vex-sidenav-toolbar__headline flex-auto" *ngIf="title$ | async">{{ title$ | async }}</h2> -->
      </div>
    }
    @if (searchVisible$ | async) {
      <div class="vex-sidenav-search__container">
        <div
          (click)="openSearch()"
          class="vex-sidenav-search relative"
          matRipple
          matRippleColor="var(--vex-sidenav-item-ripple-color)">
          <mat-icon
            class="flex-none vex-sidenav-search__icon"
            svgIcon="mat:search" />
          <div class="flex-auto vex-sidenav-search__placeholder">Quick Search</div>
          <div class="flex-none vex-sidenav-search__keybind">Ctrl K</div>
        </div>
      </div>
    }
    <!-- <div class="vex-sidenav-toolbar__divider"></div> -->
  </div>
  <vex-scrollbar class="flex-1 flex flex-col">
    @if ((hideCompany$ | async) === false) {
      <div
        class="sidenav-company"
        [ngClass]="{ 'pt-5': !isLogoEnabled }">
        <span
          class="sidenav-company-avatar"
          matBadge="!"
          matBadgeColor="primary"
          matBadgePosition="above before"
          matBadgeSize="small"
          [matBadgeHidden]="!isLocked"
          [matTooltip]="'common.account-lock.badge-tooltip' | translate"
          [matTooltipDisabled]="!isLocked"
          >{{ org | userInitials }}</span
        >
        @if (!collapsed || (collapsed && collapsedOpen)) {
          <span class="sidenav-company-label">{{ org }}</span>
        }
      </div>
    }

    <div class="pt-5 flex-1">
      @for (item of items$ | async; track trackByRoute($index, item)) {
        <rms-sidenav-item
          [item]="item"
          [level]="0"
          [showTooltip]="collapsed"
          [isWhiteLabelCustomization]="true" />
      }
    </div>
  </vex-scrollbar>

  @if (isHelpCenterEnabled && !isLogoutEnabled) {
    <a
      class="flex items-center gap-4 ml-4 mb-3"
      [class.hidden]="collapsed && !collapsedOpen"
      href="https://help.romulus.live/en/"
      target="_blank"
      area-label="Help center">
      <mat-icon
        class="icon-base min-h-6 min-w-6"
        svgIcon="remix:Business/customer-service-line" />
      <span
        class="text-nowrap"
        translate>
        menu.help
      </span>
    </a>
  }

  <div
    class="mx-3"
    [ngClass]="{ hidden: collapsed && !collapsedOpen }">
    <rms-balance-widget
      [allowOpen]="isSettingsEnabled"
      (open)="navigateToSettings()" />
  </div>

  @if (isDesktop) {
    <div class="ml-2 p-2 pb-0">
      @if (collapsed) {
        <button
          (click)="toggleCollapse()"
          class="vex-sidenav-toolbar__collapse-toggle"
          type="button">
          <mat-icon
            [matTooltip]="'menu.expand' | translate"
            matTooltipPosition="right"
            svgIcon="remix:Arrows/expand-right-line"></mat-icon>
        </button>
      } @else {
        <button
          (click)="toggleCollapse()"
          class="vex-sidenav-toolbar__collapse-toggle"
          type="button">
          <mat-icon svgIcon="remix:Arrows/expand-left-line"></mat-icon>
          <span
            class="pl-3"
            translate
            >menu.collapse</span
          >
        </button>
      }
    </div>
  }
  @if (userVisible) {
    <div class="vex-sidenav-user__container flex-none">
      <div
        class="vex-sidenav-user flex items-center"
        [matMenuTriggerFor]="isLogoutEnabled ? userMenu : null"
        [ngClass]="{ '!cursor-default': !isLogoutEnabled }"
        matRipple
        matRippleColor="var(--vex-sidenav-item-ripple-color)">
        <span class="vex-sidenav-user__image text-center bg-caeruleus p-2">
          {{ username | userInitials }}
        </span>
        <div class="vex-sidenav-user__content flex-auto">
          <div class="vex-sidenav-user__title">{{ username }}</div>
          <div class="vex-sidenav-user__subtitle"></div>
        </div>
        <mat-icon
          class="vex-sidenav-user__dropdown-icon flex-none"
          svgIcon="mat:arrow_drop_down">
        </mat-icon>
      </div>
    </div>
  }

  <mat-menu
    #userMenu="matMenu"
    yPosition="above"
    [overlapTrigger]="false"
    [hasBackdrop]="true"
    class="w-52 sidenav-user-menu">
    @if (isHelpCenterEnabled) {
      <a
        mat-menu-item
        href="https://help.romulus.live/en/"
        target="_blank"
        aria-label="Help center">
        <mat-icon svgIcon="remix:Business/customer-service-line"> </mat-icon>
        <span translate>menu.help</span>
      </a>
    }

    <button
      mat-menu-item
      (click)="logout()">
      <mat-icon svgIcon="remix:System/logout-box-line"></mat-icon>
      <span translate>user-menu.logout</span>
    </button>
  </mat-menu>
</div>
